/** Stable Gmail rule name shared by connector and digest setup surfaces. */
export const MEETING_RULE_NAME = "trusted_sender_meeting_keywords";

/** Default senders used to identify meeting-related Gmail messages. */
export const MEETING_DEFAULT_SENDERS =
  "calendar-notification@google.com, noreply@calendar.google.com, gemini-notes@google.com, no-reply@zoom.us, notifications@zoom.us, no-reply@teams.microsoft.com, no-reply@webex.com, mail.calendar.google.com, calendar.google.com";

/** Default keywords used to identify meeting-related Gmail messages. */
export const MEETING_DEFAULT_KEYWORDS =
  "meeting, zoom, google meet, teams, webex, agenda, standup, action items";
